// Action Types
const SET_LANGUAGE = 'SET_LANGUAGE';

// Action Creators
export const setLanguage = (language) => ({
  type: SET_LANGUAGE,
  payload: language,
  meta: {
    logMessage: `Language changed to: ${language}`,
  },
});